import { useContext } from 'react'
import { Formik } from 'formik'

import { ModalWrapper } from '../modal-wrapper'
import { IMediaFileWithId } from 'src/types'
import { MediaInputContext } from './context/media.context'

import { mediaInputSchema } from 'src/common/validations'
import { MediaSnapImageForm } from './media-snap-image-form.component'

import useStyles from './styles'

interface IProps {
  open: boolean
  onClose: () => void
}

const MediaSnapImageModal = ({ open, onClose }: IProps) => {
  const { image, setMedia, media } = useContext(MediaInputContext)
  const classes = useStyles({})

  const handleSubmit = (values: IMediaFileWithId) => {
    onClose()

    setMedia([...(media ?? []), values])
  }

  const intialValues: IMediaFileWithId = {
    main_image: image?.main_image ?? false,
    show_item: false,
    link_small: null,
    link_medium: null,
    link_large: null,
    editId: image?.editId,
    title: '',
    link: image?.link ?? '',
    type: image?.type ?? '',
    file: image?.file ?? null,
    dragId: `id-${Date.now()}`,
  }

  return (
    <ModalWrapper onClose={onClose} open={open} className={classes.modalWrapper}>
      <Formik
        validateOnChange={false}
        validateOnBlur={false}
        validateOnMount={false}
        onSubmit={handleSubmit}
        initialValues={intialValues}
        validationSchema={mediaInputSchema}
      >
        <MediaSnapImageForm onClose={onClose} open={open} />
      </Formik>
    </ModalWrapper>
  )
}

export { MediaSnapImageModal }
